import { z } from 'zod';
import { BaseEntitySchema } from './common';
import { GameConfigSchema } from './game-config';
import { PlayerId, SessionTemplateId, TeamId, UserId } from './ids';
import { TeamSchema } from './team';

export const SessionTemplateTeamConfigSchema = z.object({
  id: TeamId,
  presetId: TeamId.optional(),
  name: TeamSchema.shape.name,
  nickname: TeamSchema.shape.nickname,
  avatar: z.url().optional(),
  color: z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .optional(),
  playerIds: z.array(PlayerId).min(1),
});

export const SessionTemplateSchema = BaseEntitySchema.extend({
  id: SessionTemplateId,
  name: z.string().min(1).max(200),
  description: z.string().max(2000).optional(),
  gameConfig: GameConfigSchema,
  playerIds: z.array(PlayerId).min(1),
  teamConfiguration: z
    .object({
      teams: z.array(SessionTemplateTeamConfigSchema),
    })
    .optional(),
  defaultSessionName: z.string().max(200).optional(),
  userId: UserId.optional(),
});

export type SessionTemplate = z.infer<typeof SessionTemplateSchema>;
export type SessionTemplateTeamConfig = z.infer<typeof SessionTemplateTeamConfigSchema>;
